
import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import AddressModal from '../Modal/AddressModal';
import logo from '../../Images/vantaralogo.png'
const getAuthToken = () => {
  const userData = sessionStorage.getItem("userData");
  if (!userData) return "";
  try {
    const parsed = JSON.parse(userData);
    return parsed.token || "";
  } catch {
    return "";
  }
};
const MyAccount = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    country: '',
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    address: '',
    city: '',
    state: '',
    zip: '',
    profilePic: ''
  });
  const [showPassword, setShowPassword] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [activeSection, setActiveSection] = useState("account");
  const [expandedOrder, setExpandedOrder] = useState(null);
  const [deliveryAddresses, setDeliveryAddresses] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);
  const [customerId, setCustomerId] = useState(null);
  const [orders, setOrders] = useState([]);
  const [visibleReturn, setVisibleReturn] = useState(null);
  const [visibleReview, setVisibleReview] = useState(null);
  const [reviewData, setReviewData] = useState({ comment: "", rating: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [comments, setComments] = useState({});
  const [returnData, setReturnData] = useState({
    order_id: null,
    product_id: '',
    quantity: 1,
    price: '',
    notes: '',
    return_type: '',
    return_reason: '',
    product_condition: '',
    remarks: ''
  });
  const fetchComments = async (orderItemId) => {
    try {
      const token = getAuthToken();
      const response = await axios.get(
        `https://vantara.datacubeglobal.com/api/order-items/${orderItemId}/comments`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.data?.status === true || response.data?.status === "success") {
        setComments((prev) => ({
          ...prev,
          [orderItemId]: response.data.data || [],
        }));
      } else {
        setComments((prev) => ({ ...prev, [orderItemId]: [] }));
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };


  const toggleReviewForm = (id) => {
    if (visibleReview === id) {
      setVisibleReview(null);
    } else {
      setVisibleReview(id);
      setReviewData({ comment: "", rating: 0 });
      fetchComments(id);
    }
  };

useEffect(() => {
  const savedSection = localStorage.getItem("activeSection");
  if (savedSection) {
    setActiveSection(savedSection);
    localStorage.removeItem("activeSection");
  }
}, []);

  const handleAddReview = async (orderItemId, comment, rating) => {
    if (!rating || !comment) {
      Swal.fire({
        icon: "warning",
        title: "Missing Rating or Comment",
        text: "Please add Rating & Comment!",
        confirmButtonColor: "#000",
      });
      return;
    }
    try {
      const token = getAuthToken();
      const response = await axios.post(
        `https://vantara.datacubeglobal.com/api/order-items/${orderItemId}/comments`,
        { comment, rating },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
   
      if (response.data?.status === true) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data?.message || "Comment added successfully!",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          // ✅ Reset review modal and refresh orders
          setVisibleReview(null);
          setReviewData({ comment: "", rating: 0 });
          setActiveSection("orders"); // stay in orders section
          fetchOrders(); // reload orders list
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: response.data?.message || "Failed to add review. Try again.",
          confirmButtonColor: "#000",
        });
      }
    } catch (error) {
      console.error("Error adding review:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while adding the review.",
        confirmButtonColor: "#000",
      });
    }
  };

  const handleEditFormChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? (checked ? 1 : 0) : value
    }));
  };

  const openAddModal = () => {
    setEditingAddress(null);
    setModalOpen(true);
  };
  const toggleReturnForm = (id) => {
    setVisibleReturn(visibleReturn === id ? null : id);
    setReturnData({ reason: "", return_type: "", comment: "", quantity: 1 });
  };

  const openEditModal = (addr) => {
    setEditingAddress(addr);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setEditingAddress(null);
  };


  const handleAddressSaved = async () => {
    const token = getAuthToken();
    try {
      const res = await axios.get(
        "https://vantara.datacubeglobal.com/api/show-customer",
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (res.data.status === "success") {
        setDeliveryAddresses(res.data.data.delivery_address || []);
      }
    } catch (err) {
      console.error("Failed to refresh addresses:", err);
    }
  };

  const startEditing = (addr) => {
    setEditingId(addr.address_id);
    setEditForm({
      phone: addr.phone || '',
      email: addr.email || '',
      address_line1: addr.address_line1 || '',
      address_line2: addr.address_line2 || '',
      city: addr.city || '',
      state: addr.state || '',
      country: addr.country || '',
      postal_code: addr.postal_code || '',
      is_default: addr.is_default || 0
    });
  };


  const cancelEditing = () => {
    setEditingId(null);
    setEditForm({});
  };


  const saveEditedAddress = async () => {
    const token = getAuthToken();
    if (!token || !editingId) return;

    try {

      const params = new URLSearchParams({
        phone: editForm.phone,
        email: editForm.email,
        address_line1: editForm.address_line1,
        address_line2: editForm.address_line2 || '',
        city: editForm.city,
        state: editForm.state,
        country: editForm.country,
        postal_code: editForm.postal_code,
        is_default: editForm.is_default,
        customer_id: customerId,
      }).toString();

      const res = await axios.put(
        `https://vantara.datacubeglobal.com/api/delivery-address/${editingId}?${params}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      if (res.data.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Updated!",
          text: "Address updated successfully.",
          confirmButtonColor: "#7c0046"
        });

        // Refresh addresses
        const updatedRes = await axios.get(
          "https://vantara.datacubeglobal.com/api/show-customer",
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (updatedRes.data.status === "success") {
          setDeliveryAddresses(updatedRes.data.data.delivery_address || []);
        }

        cancelEditing();
      } else {
        throw new Error(res.data.message || "Update failed");
      }
    } catch (err) {
      console.error("Edit address error:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.message || "Failed to update address.",
        confirmButtonColor: "#7c0046"
      });
    }
  };

  // const fetchOrders = async () => {
  //   try {
  //     const token = getAuthToken();
  //     const response = await axios.get(
  //       "https://vantara.datacubeglobal.com/api/purchase/history",
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //     if (response.data?.status === "success") {
  //       setOrders(response.data.data || []);
  //     } else {
  //       setOrders([]);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching orders:", error);
  //     setOrders([]);
  //   }
  // };
  const fetchOrders = async () => {
    try {
      const token = getAuthToken();
      const response = await axios.get(
        "https://vantara.datacubeglobal.com/api/purchase/history",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data?.status === "success") {
        const fetchedOrders = response.data.data || [];
        setOrders(fetchedOrders.reverse());


        fetchedOrders.forEach(order => {
          order.items?.forEach(item => {
            fetchComments(item.order_item_id);
          });
        });
      } else {
        setOrders([]);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      setOrders([]);
    }
  };

  useEffect(() => {
    if (activeSection === "orders") {
      fetchOrders();
    }
  }, [activeSection]);

  // const isReturnAllowed = (item, order) => {

  //   let allowedDays = 0;

  //   if (item.sub_category_return_days && item.sub_category_return_days !== '' && Number(item.sub_category_return_days) > 0) {
  //     allowedDays = Number(item.sub_category_return_days);
  //   } else if (item.category_return_days && item.category_return_days !== '' && Number(item.category_return_days) > 0) {
  //     allowedDays = Number(item.category_return_days);
  //   }

  //   if (allowedDays === 0) return false;


  //   const baseDate =
  //     order.ordered_at ||
  //     order.order_date ||
  //     order.created_at ||
  //     order.paid_at;

  //   if (!baseDate) return false;


  //   const orderDate = new Date(baseDate);
  //   const today = new Date();

  //   orderDate.setHours(0, 0, 0, 0);
  //   today.setHours(0, 0, 0, 0);

  //   const diffDays = Math.ceil((today - orderDate) / (1000 * 60 * 60 * 24));

  //   // Step 4: Allow return within allowed days
  //   return diffDays <= allowedDays;
  // };
  const isReturnAllowed = (item, order) => {
    let allowedDays = 0;

    if (item.sub_category_return_days && Number(item.sub_category_return_days) > 0) {
      allowedDays = Number(item.sub_category_return_days);
    } else if (item.category_return_days && Number(item.category_return_days) > 0) {
      allowedDays = Number(item.category_return_days);
    }

    if (allowedDays === 0) return false;


    const baseDate =
      order.delivered_at ||
      order.delivery_date ||
      order.delivered_on ||
      order.ordered_at ||
      order.order_date ||
      order.created_at ||
      order.paid_at;

    if (!baseDate) return false;

    const deliveryDate = new Date(baseDate);
    const today = new Date();

    deliveryDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diffDays = Math.ceil((today - deliveryDate) / (1000 * 60 * 60 * 24));


    return diffDays <= allowedDays;
  };


  const deleteAddress = async (addressId) => {
    const result = await Swal.fire({
      title: "Delete Address?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#034112FF",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    });

    if (result.isConfirmed) {
      const token = getAuthToken();

      if (!token) {
        Swal.fire({
          icon: "error",
          title: "Session Expired",
          text: "Please log in again.",
          confirmButtonColor: "#7c0046"
        });
        return;
      }
      try {
        await axios.delete(
          `https://vantara.datacubeglobal.com/api/delivery-address/${addressId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );
        await Swal.fire({
          icon: "success",
          title: "Deleted!",
          text: "Your address has been deleted.",
          confirmButtonColor: "#007C53FF"
        });


        const res = await axios.get(
          "https://vantara.datacubeglobal.com/api/show-customer",
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        if (res.data.status === "success") {
          setDeliveryAddresses(res.data.data.delivery_address || []);
        }
      } catch (err) {
        console.error("Delete error:", err);
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: "Could not delete address.",
          confirmButtonColor: "#7c0046"
        });
      }
    }
  };


  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        const token = getAuthToken();
        const res = await axios.get(
          "https://vantara.datacubeglobal.com/api/show-customer",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.data.status === "success") {
          const data = res.data.data;
          setCustomerId(data.customer_id);
          setFormData({
            firstName: data.first_name || "",
            lastName: data.last_name || "",
            email: data.email || "",
            phone: data.phone || "",
            country: data.country || "",
            address: data.address || "",
            city: data.city || "",
            state: data.state || "",
            zip: data.zip || "",
            // customerId: data.customer_id || null,
            profilePic: data.profile_pic
              ? `https://vantara.datacubeglobal.com/storage/CustomerImage/${data.profile_pic}`
              : "",
          });
          setDeliveryAddresses(data.delivery_address || []);
        }
      } catch (err) {
        console.error("Error fetching customer data:", err);
      }
    };

    fetchCustomerData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const token = getAuthToken();
      const formPayload = new FormData();

      // Account fields
      formPayload.append("first_name", formData.firstName);
      formPayload.append("last_name", formData.lastName);
      formPayload.append("email", formData.email);
      formPayload.append("phone", formData.phone);
      formPayload.append("address", formData.address);
      formPayload.append("city", formData.city);
      formPayload.append("state", formData.state);
      formPayload.append("country", formData.country);
      formPayload.append("zip", formData.zip);
      formPayload.append("status", 1);

      // Profile Pic
      if (formData.profilePicFile) {
        formPayload.append("profile_pic", formData.profilePicFile);
      }

      // Password update
      if (formData.currentPassword && formData.newPassword) {
        if (formData.newPassword !== formData.confirmPassword) {
          Swal.fire({
            icon: "warning",
            title: "Password Mismatch",
            text: "New password and confirm password do not match.",
            confirmButtonColor: "#1c3f1d",
          });
          setLoading(false);
          return;
        }
        formPayload.append("old_password", formData.currentPassword);
        formPayload.append("new_password", formData.newPassword);
        formPayload.append("new_password_confirmation", formData.confirmPassword);
      }


      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/update-customer",
        formPayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (res.data.status === "success") {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: res.data.message || "Account updated successfully!",
          confirmButtonColor: "#1c3f1d",
        });

        if (formData.profilePicFile) {
          setFormData((prev) => ({
            ...prev,
            profilePic: URL.createObjectURL(formData.profilePicFile),
            profilePicFile: null,
          }));
        }

        setFormData((prev) => ({
          ...prev,
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        }));
      } else {

        let errorMsg = res.data.message || "Update failed, please try again.";

        if (res.data.errors) {
          errorMsg = Object.values(res.data.errors).flat().join("\n");
        }

        if (res.data.error) {
          errorMsg = res.data.error;
        }

        Swal.fire({
          icon: "error",
          title: "Failed",
          text: errorMsg,
          confirmButtonColor: "#1c3f1d",
        });
      }
    } catch (err) {
      console.error("Update error:", err);

      let errorMsg = "Something went wrong while updating.";
      if (err.response?.data?.errors) {
        errorMsg = Object.values(err.response.data.errors).flat().join("\n");
      } else if (err.response?.data?.message) {
        errorMsg = err.response.data.message;
      } else if (err.response?.data?.error) {
        errorMsg = err.response.data.error;
      }

      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMsg,
        confirmButtonColor: "#1c3f1d",
      });
    } finally {
      setLoading(false);
    }
  };


  const handleLogout = async () => {
    try {
      const token = getAuthToken();

      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/logout",
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.status === "success") {

        sessionStorage.clear();

        Swal.fire({
          icon: "success",
          title: "Logged Out",
          text: res.data.message || "You have been logged out successfully.",
          confirmButtonColor: "#1c3f1d",
        }).then(() => {

          window.location.href = "/";
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Logout Failed",
          text: res.data.message || "Something went wrong.",
        });
      }
    } catch (err) {
      console.error("Logout error:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable to logout. Please try again.",
      });
    }
  };


  const handleDeleteAccount = async () => {
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: "This action cannot be undone. Do you really want to delete your account?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#1c3f1d',
      cancelButtonColor: '#6c757d'
    });

    if (confirm.isConfirmed) {
      try {
        const token = getAuthToken();

        const res = await axios.delete(
          "https://vantara.datacubeglobal.com/api/customers/delete-account",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (res.data.status === "success") {
          await Swal.fire({
            icon: 'success',
            title: 'Deleted!',
            text: res.data.message || 'Your account has been deleted.',
            confirmButtonColor: '#1c3f1d'
          });


          sessionStorage.clear();
          window.location.href = "/";
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Failed!',
            text: res.data.message || 'Unable to delete account.',
            confirmButtonColor: '#1c3f1d'
          });
        }
      } catch (err) {
        console.error("Delete account error:", err);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong. Please try again.',
          confirmButtonColor: '#1c3f1d'
        });
      }
    }
  };

  const handleReturnRequest = async (item) => {
    const token = getAuthToken();
    if (!token) {
      Swal.fire("Error", "Please login to continue", "error");
      return;
    }

    const { notes, quantity, return_type, product_condition, return_reason } = returnData;



    if (!notes?.trim()) {
      Swal.fire("Error", "Please describe the reason for return", "error");
      return;
    }

    const qty = Number(quantity);
    const maxQty = Number(item.quantity);


    if (
      quantity === "" ||
      isNaN(qty) ||
      qty < 1 ||
      qty > maxQty
    ) {
      Swal.fire("Error", "Invalid return quantity", "error");
      return;
    }

    setIsSubmitting(true);

    try {
      const formData = new FormData();
      formData.append("order_id", item.order_id);
      formData.append("items[0][product_id]", item.product_id);
      formData.append("items[0][quantity]", qty);
      formData.append("items[0][price]", item.price);
      formData.append("remarks", notes);
      formData.append("return_reason", return_reason);
      formData.append("product_condition", product_condition);
      formData.append("return_type", return_type);

      const res = await axios.post(
        "https://vantara.datacubeglobal.com/api/sales-return",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );


      if (res.data.status === "success") {
        Swal.fire("Success", "Return request submitted!", "success");
        await fetchOrders();
        setVisibleReturn(null);
        setReturnData({
          notes: "", quantity: 1, return_reason: "",
          product_condition: ""
        });
      } else {
        Swal.fire("Error", res.data.message || "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Return Request Error:", error);
      const msg =
        error.response?.data?.message ||
        "Failed to submit return request. Please try again.";
      Swal.fire("Error", msg, "error");
    } finally {
      setIsSubmitting(false);
    }
  };


const downloadInvoiceFile = async (invoiceUrl, orderId) => {
  if (!invoiceUrl) {
    Swal.fire("Info", "No invoice available for this order.", "info");
    return;
  }

  try {
    const token = getAuthToken();
    // Try to fetch blob and force download (works even if CORS allows)
    const res = await axios.get(invoiceUrl, {
      responseType: "blob",
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });

    const blob = new Blob([res.data], { type: res.headers["content-type"] || "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    const fileName = (invoiceUrl.split("/").pop() || `invoice_${orderId}.pdf`).split("?")[0];
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Invoice download error:", err);
    // fallback: open URL in new tab (useful if server sends correct headers and browser can download)
    try {
      window.open(invoiceUrl, "_blank");
    } catch {
      Swal.fire("Error", "Failed to download invoice", "error");
    }
  }
};

  const handleDownload = (orderId) => {
    const order = orders.find((o) => o.order_id === orderId);
    if (!order) return;

    const total = order.items.reduce((sum, i) => sum + Number(i.total), 0).toFixed(2);
    const printedOn = new Date().toLocaleString('en-IN', {
      dateStyle: 'medium',
      timeStyle: 'short'
    });

    const formatDate = (dateStr) => {
      const date = new Date(dateStr);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };


    // Convert your imported image to a usable URL in the new window
    const logoUrl = `${window.location.origin}${logo.replace(/^.*\/Images/, '/Images')}`;

    const printContent = `
    <html>
      <head>
        <title>Invoice #${order.order_id}</title>
        <style>
          @page { margin: 20mm; }
          body {
            font-family: 'Poppins', 'Segoe UI', sans-serif;
            background-color: #f9f9f9;
            padding: 0;
            color: #333;
          }
          .invoice-container {
            max-width: 800px;
            margin: 0 auto;
            background: #fff;
            border-radius: 10px;
            box-shadow: 0 0 8px rgba(0,0,0,0.1);
            padding: 40px;
          }
          .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 2px solid #7B0045;
            padding-bottom: 15px;
          }
          .header h1 {
            color: #7B0045;
            margin: 0;
            font-size: 24px;
          }
          .header img {
            width: 140px;
            height: auto;
            object-fit: contain;
          }
          .order-info {
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
          }
          .order-info p {
            margin: 3px 0;
          }
          .section-title {
            font-weight: 600;
            margin-top: 25px;
            color: #7B0045;
            font-size: 18px;
            border-bottom: 1px solid #ddd;
            padding-bottom: 6px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 15px;
          }
          th {
            background: #7B0045;
            color: #fff;
            text-align: left;
            padding: 10px;
            font-size: 14px;
          }
          td {
            padding: 10px;
            border-bottom: 1px solid #eee;
            font-size: 14px;
          }
          tr:last-child td { border-bottom: none; }
          .totals {
            margin-top: 20px;
            text-align: right;
          }
          .totals p { margin: 5px 0; font-size: 15px; }
          .totals strong { color: #000; font-size: 16px; }
           .printed-on {
            text-align: right;
            margin-top: 30px;
            font-size: 8px;
            color: #555;
          }
          .footer {
            text-align: center;
            margin-top: 40px;
            font-size: 13px;
            color: #888;
            border-top: 1px solid #eee;
            padding-top: 10px;
          }
        </style>
      </head>
      <body>
        <div class="invoice-container">
          <div class="header">
            <div>
              <h1>Invoice</h1>
              <p>Order ID: <strong>${order.order_id}</strong></p>
              <p>Date: ${formatDate(order.paid_at)}</p>
            </div>
            <div>
              <img src="${logoUrl}" alt="Vantara Logo" />
            </div>
          </div>

          <div class="order-info">
            <div>
              <p><strong>Status:</strong> ${order.status}</p>
          
            </div>
            <div>
              <p><strong>Customer:</strong> ${formData.firstName || 'Guest User'}</p>
              <p><strong>Email:</strong> ${formData.email || '-'}</p>
                 <p><strong>Phone:</strong> ${formData.phone || '-'}</p>
            </div>
          </div>

          <div class="section-title">Order Summary</div>
          <table>
            <thead>
              <tr>
                <th>Product</th>
                <th>Qty</th>
                <th>Price (₹)</th>
                <th>Total (₹)</th>
              </tr>
            </thead>
            <tbody>
              ${order.items.map(item => `
                <tr>
                  <td>${item.product_name}</td>
                  <td>${item.quantity}</td>
                  <td>${Number(item.price).toFixed(2)}</td>
                  <td>${Number(item.total).toFixed(2)}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>

          <div class="totals">
            <p>Subtotal: ₹${total}</p>
            <p>Tax: ₹${order.total_tax_amount}</p>
            <p>Discount: ₹${order.discount}</p>
            <p><strong>Grand Total: ₹${order.total_amount}</strong></p>
          </div>
  
          <div class="footer">
            <p>Thank you for shopping with us!</p>
            <p>For support, contact: vantara@gmail.com</p>
             <div class="printed-on">
            <p><em>Printed on: ${printedOn}</em></p>
          </div>
          </div>
        </div>

        <script>window.onload = function(){ window.print(); }</script>
      </body>
    </html>
  `;

    const newWindow = window.open("", "_blank");
    newWindow.document.write(printContent);
    newWindow.document.close();
  };

  return (
    <div className="container-fluid"><br />
      <div className="row justify-content-center">
        <div className="col-md-12">
          <div className="row">
            {/* Sidebar */}
            <div className="col-md-4 mb-4">
              <div className="card shadow-sm border-0 rounded-4 p-4">
                <div className="text-center mb-4">
                  <img
                    src={
                      formData.profilePic
                        ? formData.profilePic
                        : "https://img.freepik.com/premium-vector/avatar-profile-icon-flat-style-female-user-profile-vector-illustration-isolated-background-women-profile-sign-business-concept_157943-38866.jpg?semt=ais_hybrid&w=740&q=80"
                    }
                    alt="Profile"
                    className="rounded-circle img-fluid mb-3"
                    style={{ width: '100px', height: '100px', objectFit: 'cover' }}
                  />

                  <h5 className="mb-1">{formData.firstName} {formData.lastName}</h5>
                  <p className="text-muted mb-0">{formData.email}</p>
                </div>

                <ul className="list-unstyled">
                  <li className="mb-3">
                    <button
                      onClick={() => setActiveSection("account")}
                      className={`btn w-100 text-start py-3 border-0 rounded-3 ${activeSection === "account" ? "btn-light shadow-sm" : "btn-light text-dark"}`}
                    >
                      <i className="bi bi-person me-2"></i> Account Details
                    </button>
                  </li>
                  <li className="mb-3">
                    <button
                      onClick={() => setActiveSection("orders")}
                      className={`btn w-100 text-start py-3 border-0 rounded-3 ${activeSection === "orders" ? "btn-light shadow-sm" : "btn-light text-dark"}`}
                    >
                      <i className="bi bi-box-seam me-2"></i> Your Orders
                    </button>
                  </li>
                  <li className="mb-3">
                    <button
                      onClick={() => setActiveSection("address")}
                      className={`btn w-100 text-start py-3 border-0 rounded-3 ${activeSection === "address" ? "btn-light shadow-sm" : "btn-light text-dark"}`}
                    >
                      <i className="bi bi-geo-alt me-2"></i> My Address
                    </button>
                  </li>
                  <li>
                    <button className="btn btn-light w-100 text-start py-3 border-0 rounded-3 text-dark" onClick={handleLogout}>
                      <i className="bi bi-box-arrow-right me-2"></i> Logout
                    </button>
                  </li>
                  <li className="mt-3">
                    <button
                      className="btn btn-light w-100 text-start py-3 border-0 rounded-3"
                      onClick={handleDeleteAccount}
                    >
                      <i className="bi bi-trash3 me-2"></i> Delete Account
                    </button>
                  </li>

                </ul>
              </div>
            </div>

            {/* Right Side Content */}
            <div className="col-md-8">
              <div className="card shadow-sm border-0 rounded-4 p-4">

                {activeSection === "account" && (
                  <form onSubmit={handleSubmit}>
                    {/* Info */}
                    <div className="mb-5">
                      <h5 className="mb-4">Information</h5>
                      <div className="row mb-3  g-3">
                        <div className="col-md-6">
                          <input
                            className="form-control border-1 rounded-3"
                            placeholder="First Name"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <input
                            className="form-control border-1 rounded-3"
                            placeholder="Last Name"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="row mb-3  g-3">
                        <div className="col-md-6">
                          <input
                            type="email"
                            className="form-control border-1 rounded-3"
                            placeholder="Email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="col-md-6">
                          <input
                            type="tel"
                            className="form-control border-1 rounded-3"
                            placeholder="Phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className="row mb-3  g-3">
                        <div className="col-md-6">



                          <input
                            type=""
                            className="form-control border-1 rounded-3"
                            placeholder="address"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                          />

                        </div>


                        <div className="col-md-6 ">



                          <input
                            type=""
                            className="form-control border-1 rounded-3"
                            placeholder="city"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                          />

                        </div>
                      </div>
                      <div className="row mb-3  g-3">
                        <div className="col-md-4">
                          {/* <input
                            type=""
                            className="form-control border-1 rounded-3"
                            placeholder="state"
                            name="state"
                            value={formData.state}
                            onChange={handleChange}
                          /> */}
<select
  className="form-control border-1 rounded-3"
  name="state"
  value={formData.state}
  onChange={handleChange}
>
 <option value="Andhra Pradesh (AP)">Andhra Pradesh (AP)</option>
<option value="Arunachal Pradesh (AR)">Arunachal Pradesh (AR)</option>
<option value="Assam (AS)">Assam (AS)</option>
<option value="Bihar (BR)">Bihar (BR)</option>
<option value="Chhattisgarh (CG)">Chhattisgarh (CG)</option>
<option value="Goa (GA)">Goa (GA)</option>
<option value="Gujarat (GJ)">Gujarat (GJ)</option>
<option value="Haryana (HR)">Haryana (HR)</option>
<option value="Himachal Pradesh (HP)">Himachal Pradesh (HP)</option>
<option value="Jharkhand (JH)">Jharkhand (JH)</option>
<option value="Karnataka (KA)">Karnataka (KA)</option>
<option value="Kerala (KL)">Kerala (KL)</option>
<option value="Madhya Pradesh (MP)">Madhya Pradesh (MP)</option>
<option value="Maharashtra (MH)">Maharashtra (MH)</option>
<option value="Manipur (MN)">Manipur (MN)</option>
<option value="Meghalaya (ML)">Meghalaya (ML)</option>
<option value="Mizoram (MZ)">Mizoram (MZ)</option>
<option value="Nagaland (NL)">Nagaland (NL)</option>
<option value="Odisha (OD)">Odisha (OD)</option>
<option value="Punjab (PB)">Punjab (PB)</option>
<option value="Rajasthan (RJ)">Rajasthan (RJ)</option>
<option value="Sikkim (SK)">Sikkim (SK)</option>
<option value="Tamil Nadu (TN)">Tamil Nadu (TN)</option>
<option value="Telangana (TS)">Telangana (TS)</option>
<option value="Tripura (TR)">Tripura (TR)</option>
<option value="Uttar Pradesh (UP)">Uttar Pradesh (UP)</option>
<option value="Uttarakhand (UK)">Uttarakhand (UK)</option>
<option value="West Bengal (WB)">West Bengal (WB)</option>


<option value="Andaman and Nicobar Islands (AN)">Andaman and Nicobar Islands (AN)</option>
<option value="Chandigarh (CH)">Chandigarh (CH)</option>
<option value="Dadra and Nagar Haveli and Daman and Diu (DN)">
  Dadra and Nagar Haveli and Daman and Diu (DN)
</option>
<option value="Delhi (DL)">Delhi (DL)</option>
<option value="Jammu and Kashmir (JK)">Jammu and Kashmir (JK)</option>
<option value="Ladakh (LA)">Ladakh (LA)</option>
<option value="Lakshadweep (LD)">Lakshadweep (LD)</option>
<option value="Puducherry (PY)">Puducherry (PY)</option>

</select>


                        </div>
                        <div className="col-md-4">



                          <input
                            type=""
                            className="form-control border-1 rounded-3"
                            placeholder="Country"
                            name="country"
                            value={formData.country}
                            onChange={handleChange}
                          />

                        </div>
                        <div className="col-md-4">



                          <input
                            type=""
                            className="form-control border-1 rounded-3"
                            placeholder="zip"
                            name="zip"
                            value={formData.zip}
                            onChange={handleChange}
                          />

                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Profile Picture</label>
                        <input
                          type="file"
                          accept="image/*"
                          className="form-control"
                          onChange={(e) => {
                            if (e.target.files && e.target.files[0]) {
                              setFormData(prev => ({
                                ...prev,
                                profilePicFile: e.target.files[0]
                              }));
                            }
                          }}
                        />
                      </div>



                    </div>

                    {/* Passwords */}
                    <div>
                      <h5 className="mb-4">Change Password</h5>

                      {/* Current Password */}
                      <div className="row mb-3">
                        <div className="col-md-12">
                          <div className="input-group">
                            <input
                              type={showPassword.current ? "text" : "password"}
                              className="form-control border-1 rounded-3"
                              placeholder="Password*"
                              name="currentPassword"
                              value={formData.currentPassword}
                              onChange={handleChange}
                            />
                            <button
                              className="btn btn-outline-secondary border-1 rounded-3"
                              type="button"
                              onClick={() =>
                                setShowPassword((prev) => ({ ...prev, current: !prev.current }))
                              }
                            >
                              <i className={`bi ${showPassword.current ? "bi-eye" : "bi-eye-slash"}`}></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* New Password */}
                      <div className="row mb-3">
                        <div className="col-md-12">
                          <div className="input-group">
                            <input
                              type={showPassword.new ? "text" : "password"}
                              className="form-control border-1 rounded-3"
                              placeholder="New Password*"
                              name="newPassword"
                              value={formData.newPassword}
                              onChange={handleChange}
                            />
                            <button
                              className="btn btn-outline-secondary border-1 rounded-3"
                              type="button"
                              onClick={() =>
                                setShowPassword((prev) => ({ ...prev, new: !prev.new }))
                              }
                            >
                              <i className={`bi ${showPassword.new ? "bi-eye" : "bi-eye-slash"}`}></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Confirm Password */}
                      <div className="row mb-4">
                        <div className="col-md-12">
                          <div className="input-group">
                            <input
                              type={showPassword.confirm ? "text" : "password"}
                              className="form-control border-1 rounded-3"
                              placeholder="Confirm Password*"
                              name="confirmPassword"
                              value={formData.confirmPassword}
                              onChange={handleChange}
                            />
                            <button
                              className="btn btn-outline-secondary border-1 rounded-3"
                              type="button"
                              onClick={() =>
                                setShowPassword((prev) => ({ ...prev, confirm: !prev.confirm }))
                              }
                            >
                              <i className={`bi ${showPassword.confirm ? "bi-eye" : "bi-eye-slash"}`}></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div className="text-start">
                        <button
                          type="submit"
                          style={{ backgroundColor: "#7c0046", color: "#fff" }}
                          className="btn px-4 py-2 font-weight-bold rounded-pill"
                        >
                          Update Account
                        </button>
                      </div>
                    </div>

                  </form>
                )}


                {activeSection === "orders" && (
                  <div>
                    <h5 className="mb-4">My Orders</h5>
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Order</th>
                          <th>Date</th>
                          {/* <th>Status</th> */}
                          <th>Total</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orders.length === 0 ? (
                          <tr>
                            <td colSpan="5" className="text-center text-muted py-4">
                              No orders found.
                            </td>
                          </tr>
                        ) : (
                          orders.map((order) => (
                            <React.Fragment key={order.order_id}>
                              <tr>
                                <td>#{order.order_id}</td>
                                <td>
                                  {new Date(order.paid_at).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  })}
                                </td>

                                {/* <td className="text-capitalize">{order.status || "Pending"}</td> */}
                                <td>₹{order.total_amount}</td>
                                <td>
                                  <button
                                    className="btn btn-sm rounded-pill"
                                    style={{ backgroundColor: "#7c0046", color: "#fff" }}
                                    onClick={() =>
                                      setExpandedOrder(expandedOrder === order.order_id ? null : order.order_id)
                                    }
                                  >
                                    {expandedOrder === order.order_id ? "Hide" : "View"}
                                  </button>
                                    {order.status === "despatched" && (
                                  <button
                                    className="btn btn-sm rounded-pill ms-2 d-none d-md-inline"
                                    style={{ backgroundColor: "#333", color: "#fff" }}
                                   onClick={() => downloadInvoiceFile(order.invoice, order.order_id)}
                                  >
                                    Invoice
                                  </button>
                                    )}
                                </td>
                              </tr>


                              {expandedOrder === order.order_id && (
                                <tr>
                                  <td colSpan="6" >
                                    <div className="p-4 bg-white rounded shadow-sm border" >
                                      <h6 className="fw-bold mb-3 d-flex justify-content-between align-items-center">
                                        <span>Order Details</span>
                                        <span
                                          className={`badge rounded-pill ${order.status === "Ordered" ? "bg-info text-dark" :
                                            order.status === "rejected" ? "bg-danger text-light" :
                                              order.status === "confirmed" ? "bg-primary text-light" :
                                                order.status === "processing" ? "bg-warning text-dark" :
                                                  order.status === "despatched" ? "bg-secondary text-light" :
                                                    order.status === "ontransist" ? "bg-dark text-light" :
                                                      order.status === "delivered" ? "bg-success text-light" :
                                                        "bg-secondary text-light"
                                            }`}
                                        >
                                          {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
                                        </span>
                                        {order?.return_status && (
                                          <span
                                            className={`badge rounded-pill ms-2 ${order.return_status.toLowerCase() === "requested" ? "bg-warning text-dark" :
                                                order.return_status.toLowerCase() === "accepted" ? "bg-primary text-light" :
                                                  order.return_status.toLowerCase() === "rejected" ? "bg-danger text-light" :
                                                    order.return_status.toLowerCase() === "picked" ? "bg-info text-dark" :
                                                      order.return_status.toLowerCase() === "collected" ? "bg-secondary text-light" :
                                                        order.return_status.toLowerCase() === "refunded" ? "bg-success text-light" :
                                                          order.return_status.toLowerCase() === "replaced" ? "bg-success text-light" :
                                                            "bg-secondary text-light"
                                              }`}
                                          >
                                            {order.return_status?.charAt(0).toUpperCase() + order.return_status?.slice(1) || "N/A"}
                                          </span>
                                        )}
                                      </h6>


                                      {order.items && order.items.length > 0 ? (
                                        order.items.map((item, i) => (
                                          <div key={i} className="border-bottom pb-3 mb-3">
                                            <div className="d-flex align-items-center flex-wrap flex-md-nowrap">
                                              {/* Product Image */}
                                              <div className="ms-0 mb-2 mb-md-0 text-center">
                                                <img
                                                  src={`https://vantara.datacubeglobal.com/storage/${item.primary_image || ""}`}
                                                  alt={item.product?.product_name || "Product"}
                                                  style={{
                                                    width: "70px",
                                                    height: "70px",
                                                    objectFit: "cover",
                                                    borderRadius: "8px",
                                                  }}
                                                />

                                                {/* Buttons under image for mobile */}

                                              </div>

                                              {/* Product Info */}
                                              <div className="flex-grow-1 ms-2">
                                                <h6 className="mb-1">{item.product_name}</h6>
                                                <p className="mb-0 small text-muted">
                                                  Qty: {item.quantity} × ₹{item.price}
                                                </p>

                                                {/* Return Status Badge */}
                                                {item.return_status && item.return_status.trim() !== "" ? (
                                                  <span
                                                    className={`badge rounded-pill mt-1 ${item.return_status.toLowerCase() === "requested"
                                                        ? "bg-warning text-dark"
                                                        : item.return_status.toLowerCase() === "accepted"
                                                          ? "bg-primary text-light"
                                                          : item.return_status.toLowerCase() === "rejected"
                                                            ? "bg-danger text-light"
                                                            : item.return_status.toLowerCase() === "picked" ||
                                                              item.return_status.toLowerCase() === "picked up"
                                                              ? "bg-info text-dark"
                                                              : item.return_status.toLowerCase() === "collected"
                                                                ? "bg-secondary text-light"
                                                                : item.return_status.toLowerCase() === "refunded"
                                                                  ? "bg-success text-light"
                                                                  : item.return_status.toLowerCase() === "replaced"
                                                                    ? "bg-success text-light"
                                                                    : "bg-light text-muted"
                                                      }`}
                                                  >
                                                    {item.return_status.charAt(0).toUpperCase() + item.return_status.slice(1)}
                                                  </span>
                                                ) : (
                                                  <span className="badge rounded-pill mt-1 bg-light text-muted">
                                                   
                                                  </span>
                                                )}
                                              </div>

                                              <div className="d-flex d-md-none justify-content-center gap-2 mt-2">

                                                {(order.status === "delivered") && (
                                                  <button
                                                    className="btn btn-outline-success btn-sm rounded-pill"
                                                    onClick={() => toggleReviewForm(item.order_item_id)}
                                                    onMouseEnter={(e) => {
                                                      e.target.style.backgroundColor = '#1C3F1D';
                                                      e.target.style.color = '#fff';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                      e.target.style.backgroundColor = 'transparent';
                                                      e.target.style.color = '#1C3F1D';
                                                    }}
                                                  >
                                                    {visibleReview === item.order_item_id ? "Cancel" : "Add Review"}
                                                  </button>

                                                )}



                                                {(order.status === "delivered") && (
                                                  <button
                                                    className="btn btn-outline-danger btn-sm rounded-pill"
                                                    onClick={() => toggleReturnForm(item.order_item_id)}
                                                    disabled={item.is_returned || !isReturnAllowed(item, order)}
                                                    style={{
                                                      cursor: item.is_returned || !isReturnAllowed(item, order)
                                                        ? "not-allowed"
                                                        : "pointer",
                                                      opacity: item.is_returned || !isReturnAllowed(item, order)
                                                        ? 0.5
                                                        : 1,
                                                    }}
                                                  >
                                                    {item.is_returned
                                                      ? "Already Returned"
                                                      : !isReturnAllowed(item, order)
                                                        ? "Return Expired"
                                                        : visibleReturn === item.order_item_id
                                                          ? "Cancel Return"
                                                          : "Request Return"}
                                                  </button>
                                                )}


                                              </div>

                                              <div className="d-none d-md-flex ms-3">

                                                {(order.status === "delivered") && (
                                                  <button
                                                    className="btn btn-outline-dark btn-sm rounded-pill me-2"
                                                     style={{ minWidth: "110px" }}
                                                    onClick={() => toggleReviewForm(item.order_item_id)}
                                                    onMouseEnter={(e) => {
                                                      e.target.style.backgroundColor = '#1C3F1D';
                                                      e.target.style.color = '#fff';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                      e.target.style.backgroundColor = 'transparent';
                                                      e.target.style.color = '#1C3F1D';
                                                    }}
                                                  >
                                                    {visibleReview === item.order_item_id ? "Cancel" : "Add Review"}
                                                  </button>
                                                )}



                                                {/* Return Button */}
                                                {(order.status === "delivered") && (
                                                  <button
                                                    className="btn btn-outline-danger btn-sm rounded-pill"
                                                    onClick={() => toggleReturnForm(item.order_item_id)}
                                                    disabled={item.is_returned || !isReturnAllowed(item, order)}
                                                    style={{
                                                       minWidth: "130px", 
                                                      cursor: item.is_returned || !isReturnAllowed(item, order)
                                                        ? "not-allowed"
                                                        : "pointer",
                                                      opacity: item.is_returned || !isReturnAllowed(item, order)
                                                        ? 0.5
                                                        : 1,
                                                    }}
                                                  >
                                                    {item.is_returned
                                                      ? "Already Returned"
                                                      : !isReturnAllowed(item, order)
                                                        ? "Return Expired"
                                                        : visibleReturn === item.order_item_id
                                                          ? "Cancel Return"
                                                          : "Request Return"}
                                                  </button>
                                                )}



                                              </div>
                                            </div>


                                            {/* Review Form */}
                                            {visibleReview === item.order_item_id && (
                                              <div className="mt-3 p-3 bg-light rounded">
                                                <div className="mb-2 d-flex align-items-center">
                                                  {[1, 2, 3, 4, 5].map((star) => (
                                                    <i
                                                      key={star}
                                                      className={`bi ${reviewData.rating >= star
                                                        ? "bi-star-fill text-warning"
                                                        : "bi-star text-secondary"
                                                        } fs-4 me-1`}
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() =>
                                                        setReviewData({
                                                          ...reviewData,
                                                          rating: star,
                                                        })
                                                      }
                                                    ></i>
                                                  ))}
                                                </div>
                                                <textarea
                                                  className="form-control mb-2"
                                                  placeholder="Write your review..."
                                                  value={reviewData.comment || ""}
                                                  onChange={(e) =>
                                                    setReviewData({
                                                      ...reviewData,
                                                      comment: e.target.value,
                                                    })
                                                  }
                                                /><br />
                                                   <div className="text-end">
                                                <button
                                                  className="btn btn-sm rounded-pill"
                                                  style={{ backgroundColor: "#7c0046", color: "#fff" }}
                                                  onClick={() =>
                                                    handleAddReview(
                                                      item.order_item_id,
                                                      reviewData.comment,
                                                      reviewData.rating
                                                    )
                                                  }
                                                >
                                                  Submit Review
                                                </button>
                                                </div>
                                            
                                              </div>
                                            )}
                                            {comments[item.order_item_id] && comments[item.order_item_id].length > 0 ? (
                                              <div className="mt-2 p-2 bg-light rounded">
                                                <h6 className="fw-bold mb-2">Customer Reviews:</h6>
                                                {comments[item.order_item_id].map((comment, index) => (
                                                  <div key={index} className="border-bottom pb-2 mb-2">
                                                    <p className="mb-1">{comment.comment}</p>
                                                    <small className="text-muted">
                                                      ⭐ {comment.rating} / 5 — {comment.user_name || "You"}
                                                    </small>
                                                  </div>
                                                ))}
                                              </div>
                                            ) : (
                                              <p className="text-muted small mt-2"></p>
                                            )}


                                            {/* Return Form */}
                                            {visibleReturn === item.order_item_id && (
                                              <div className="mt-3 p-3 bg-light rounded">
                                                <h6 className="fw-bold mb-2">Return Request</h6>

                                                {/* Notes / Reason */}
                                                <textarea
                                                  className="form-control mb-2"
                                                  placeholder="Describe the issue (e.g., damage, leakage, wrong item...)"
                                                  value={returnData.notes || ""}
                                                  onChange={(e) =>
                                                    setReturnData({
                                                      ...returnData,
                                                      notes: e.target.value,
                                                    })
                                                  }
                                                ></textarea>


                                                <input
                                                  type="hidden"
                                                  value={item.order_id}
                                                  onChange={(e) =>
                                                    setReturnData({
                                                      ...returnData,
                                                      order_id: e.target.value,
                                                    })
                                                  }
                                                />


                                                <input
                                                  type="hidden"
                                                  value={item.product_id || ''}
                                                  onChange={(e) =>
                                                    setReturnData({
                                                      ...returnData,
                                                      product_id: e.target.value,
                                                    })
                                                  }
                                                />

                                                {/* Quantity to return */}
                                                <div className="mb-2">
                                                  <label className="form-label">Quantity to Return</label>
                                                  <input
                                                    type="number"
                                                    className="form-control"
                                                    min="1"
                                                    max={item.quantity || 1}
                                                    value={returnData.quantity || 1}
                                                    onChange={(e) => {
                                                      let value = parseInt(e.target.value) || 1;
                                                      const maxQty = item.quantity || 1;

                                                      // Clamp value between 1 and maxQty
                                                      if (value < 1) value = 1;
                                                      if (value > maxQty) value = maxQty;

                                                      setReturnData({
                                                        ...returnData,
                                                        quantity: value,
                                                      });
                                                    }}
                                                  />
                                                </div>


                                                <input
                                                  type="hidden"
                                                  value={item.price || ''}
                                                  onChange={(e) =>
                                                    setReturnData({
                                                      ...returnData,
                                                      price: parseFloat(e.target.value) || 0,
                                                    })
                                                  }
                                                />
                                                <div className="mb-3">
                                                  <label className="form-label">Product Condition</label>
                                                  <select
                                                    className="form-select"
                                                    value={returnData.product_condition || ""}
                                                    onChange={(e) =>
                                                      setReturnData({
                                                        ...returnData,
                                                        product_condition: e.target.value,
                                                      })
                                                    }
                                                  >
                                                    <option value="">-- Select Condition --</option>
                                                    <option value="damaged">Damaged</option>
                                                    <option value="unused">Un-Used</option>
                                                    <option value="opened">Opened</option>
                                                    <option value="other">Other</option>
                                                  </select>
                                                </div>
                                                {returnData.product_condition === "other" && (
                                                  <div className="mb-2">
                                                    <label className="form-label">Return Reason</label>
                                                    <input
                                                      // type="text"
                                                      className="form-control"
                                                      placeholder="Please specify your reason"
                                                      value={returnData.return_reason || ""}
                                                      onChange={(e) =>
                                                        setReturnData({
                                                          ...returnData,
                                                          return_reason: e.target.value,
                                                        })
                                                      }
                                                    />
                                                  </div>
                                                )}
                                                <div className="mb-2">
                                                  <label className="form-label fw-semibold">Return Type</label>
                                                  <select
                                                    className="form-select"
                                                    value={returnData.return_type || ""}
                                                    onChange={(e) =>
                                                      setReturnData({ ...returnData, return_type: e.target.value })
                                                    }
                                                  >
                                                    <option value="">-- Select Type --</option>
                                                    <option value="refund">Refund</option>
                                                    <option value="replacement">Exchange</option>
                                                  </select>
                                                </div>

                                                <div className="text-end">
                                                  <button
                                                    className="btn btn-sm btn-danger rounded-pill"
                                                    onClick={() => handleReturnRequest(item)}
                                                    disabled={isSubmitting}
                                                  >
                                                    {isSubmitting ? (
                                                      <>
                                                        <span
                                                          className="spinner-border spinner-border-sm me-2"
                                                          role="status"
                                                          aria-hidden="true"
                                                        ></span>
                                                        Submitting...
                                                      </>
                                                    ) : (
                                                      "Submit Return"
                                                    )}
                                                  </button>
                                                </div>

                                              </div>
                                            )}
                                          </div>
                                        ))
                                      ) : (
                                        <p className="text-muted mb-0">No items found.</p>
                                      )}

                                      <div className="mt-3 d-flex justify-content-between align-items-center">
                                        <div>
                                          <strong>Total Amount:</strong> ₹{order.total_amount}
                                          <br />
                                          <strong>Tax:</strong> ₹{order.total_tax_amount}
                                          <br />
                                          <strong>Discount:</strong> ₹{order.discount}
                                        </div>

                                        {/* 🧾 Download PDF icon */}
                                        <button
                                          className="btn btn-light border rounded-circle ms-3 d-inline d-md-none"
                                          style={{
                                            width: "40px",
                                            height: "40px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
                                          }}
                                          onClick={() => handleDownload(order.order_id)}
                                        >
                                          <i className="bi bi-download fs-5 text-dark"></i>
                                        </button>
                                      </div>

                                    </div>
                                  </td>

                                </tr>
                              )}

                            </React.Fragment>
                          ))
                        )}

                      </tbody>
                    </table>

                  </div>
                )}

                {activeSection === "address" && (
                  <div>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h5 className="mb-0">My Addresses</h5>
                      <button
                        className="btn btn-sm d-flex align-items-center gap-1"
                        style={{ backgroundColor: "#7c0046", color: "#fff" }}
                        onClick={openAddModal}
                      >
                        <i className="bi bi-plus-circle"></i>  Address
                      </button>
                    </div>

                    {deliveryAddresses.length > 0 ? (
                      <div className="d-flex flex-column gap-3">
                        {deliveryAddresses.map((addr) => (
                          <div
                            key={addr.address_id}
                            className={`card rounded-3 ${addr.is_default ? "" : ""
                              }`}
                          >
                            {editingId === addr.address_id ? (
                              // Edit Form
                              <div className="card-body p-4">
                                <div className="row g-3">
                                  {/* ===== Address Info ===== */}
                                  <div className="col-12">
                                    <h6 className="fw-bold mb-2">Address Details</h6>
                                    <hr className="mt-0 mb-3" />
                                  </div>

                                  <div className="col-md-6">
                                    <label className="form-label small fw-medium">Address Line 1</label>
                                    <input
                                      // type="text"
                                      className="form-control"
                                      name="address_line1"
                                      value={editForm.address_line1}
                                      onChange={handleEditFormChange}
                                      required
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <label className="form-label small fw-medium">Address Line 2</label>
                                    <input
                                      // type="text"
                                      className="form-control"
                                      name="address_line2"
                                      value={editForm.address_line2}
                                      onChange={handleEditFormChange}
                                    />
                                  </div>

                                  <div className="col-md-4">
                                    <label className="form-label small fw-medium">District</label>
                                    <input
                                      // type="text"
                                      className="form-control"
                                      name="city"
                                      value={editForm.city}
                                      onChange={handleEditFormChange}
                                      required
                                    />
                                  </div>
                                  <div className="col-md-4">
                                    <label className="form-label small fw-medium">State</label>
                                    <input
                                      // type="text"
                                      className="form-control"
                                      name="state"
                                      value={editForm.state}
                                      onChange={handleEditFormChange}
                                      required
                                    />
                                  </div>
                                  <div className="col-md-4">
                                    <label className="form-label small fw-medium">Postal Code</label>
                                    <input
                                      // type="text"
                                      className="form-control"
                                      name="postal_code"
                                      value={editForm.postal_code}
                                      onChange={handleEditFormChange}
                                      required
                                    />
                                  </div>

                                  <div className="col-md-6">
                                    <label className="form-label small fw-medium">Country</label>
                                    <input
                                      // type="text"
                                      className="form-control"
                                      name="country"
                                      value={editForm.country}
                                      onChange={handleEditFormChange}
                                      required
                                    />
                                  </div>

                                  {/* ===== Contact Info ===== */}
                                  <div className="col-12 mt-4">
                                    <h6 className="fw-bold mb-2">Contact Info</h6>
                                    <hr className="mt-0 mb-3" />
                                  </div>

                                  <div className="col-md-6">
                                    <label className="form-label small fw-medium">Email</label>
                                    <input
                                      type="email"
                                      className="form-control"
                                      name="email"
                                      value={editForm.email}
                                      onChange={handleEditFormChange}
                                      required
                                    />
                                  </div>
                                  <div className="col-md-6">
                                    <label className="form-label small fw-medium">Phone</label>
                                    <input
                                      type="tel"
                                      className="form-control"
                                      name="phone"
                                      value={editForm.phone}
                                      onChange={handleEditFormChange}
                                      required
                                    />
                                  </div>

                                  {/* ===== Options ===== */}
                                  <div className="col-12 mt-4">
                                    <h6 className="fw-bold mb-2">Options</h6>
                                    <hr className="mt-0 mb-3" />
                                  </div>

                                  <div className="col-12">
                                    <div className="form-check">
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`default-${addr.address_id}`}
                                        name="is_default"
                                        checked={editForm.is_default === 1}
                                        onChange={handleEditFormChange}
                                      />
                                      <label
                                        className="form-check-label fw-medium"
                                        htmlFor={`default-${addr.address_id}`}
                                      >
                                        Set as default shipping address
                                      </label>
                                    </div>
                                  </div>

                                  {/* ===== Actions ===== */}
                                  <div className="col-12 d-flex gap-2 justify-content-end mt-4">
                                    <button
                                      className="btn btn-sm btn-outline-secondary rounded-pill px-3"
                                      onClick={cancelEditing}
                                    >
                                      Cancel
                                    </button>
                                    <button
                                      className="btn btn-sm rounded-pill px-3"
                                      style={{ backgroundColor: "#7c0046", color: "#fff" }}
                                      onClick={saveEditedAddress}
                                    >
                                      Save Changes
                                    </button>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              // View Mode
                              //                               <div className="card-body p-4">
                              //                                 <div className="d-flex justify-content-between align-items-start flex-wrap">
                              //                                   <div>
                              //                                     <h6 className="fw-bold mb-1">
                              //                                       {addr.address_line1}
                              //                                     </h6>
                              //                                     <h8>{addr.address_line2}</h8>
                              //                                     <p className="text-muted mb-1">
                              //                                       {addr.city}, {addr.state}, {addr.country} {addr.postal_code}
                              //                                     </p>
                              //                                     <p className="text-muted mb-2">
                              //                                       <i className="bi bi-telephone-fill me-1"></i> {addr.phone}
                              //                                       {addr.email && (
                              //                                         <>
                              //                                           {" • "}
                              //                                           <i className="bi bi-envelope-fill me-1"></i> {addr.email}
                              //                                         </>
                              //                                       )}
                              //                                     </p>

                              //                                     {addr.is_default === 1 && (
                              //                                       <span className="badge" style={{ backgroundColor: "#1C3F1D" }}>
                              //                                         Default
                              //                                       </span>

                              //                                     )}
                              //                                   </div>
                              //                                   <div className="d-flex flex-row gap-2 mt-2 mt-md-0">
                              //                                     <button
                              //                                       className="btn btn-sm btn-outline-dark rounded-pill px-3"
                              //                                       style={{ borderColor: "#1C3F1D", color: "#FFFFFFFF",backgroundColor:'#1C3F1D' }}
                              //                                       onClick={() => startEditing(addr)}
                              //                                     >
                              //                                       Edit
                              //                                     </button>
                              //                                     <button
                              //                                       className="btn btn-sm  rounded-pill px-3"

                              //  style={{ borderColor: "#880505FF", color: "#FFFFFFFF",backgroundColor:'#880505FF' }}
                              //                                       onClick={() => deleteAddress(addr.address_id)}
                              //                                     >
                              //                                       Delete
                              //                                     </button>
                              //                                   </div>
                              //                                 </div>

                              //                               </div>
                              <div className="card-body p-4">
                                {/* Address header line (address + buttons) */}
                                <div className="d-flex justify-content-between align-items-center flex-wrap mb-2">
                                  <h6 className="fw-bold mb-0">{addr.address_line1}</h6>
                                  <div className="d-flex gap-2 align-items-center">
                                    <button
                                      className="btn btn-sm btn-outline-dark rounded-pill px-3 edit-btn"


                                      style={{
                                        borderColor: "#1C3F1D",
                                        color: "#fff",
                                        backgroundColor: "#1C3F1D",
                                        transition: "0.3s",
                                      }}
                                      onClick={() => startEditing(addr)}
                                    >
                                      Edit
                                    </button>
                                    <button
                                      className="btn btn-sm rounded-pill px-3 delete-btn"
                                      style={{
                                        borderColor: "#880505",
                                        color: "#fff",
                                        backgroundColor: "#880505",
                                        transition: "0.3s",
                                      }}
                                      onClick={() => deleteAddress(addr.address_id)}
                                    >
                                      Delete
                                    </button>
                                  </div>
                                </div>

                                {/* Address details below */}
                                <p className="mb-1">{addr.address_line2}</p>
                                <p className="text-muted mb-1">
                                  {addr.city}, {addr.state}, {addr.country} {addr.postal_code}
                                </p>
                                <p className="text-muted mb-2" style={{ whiteSpace: "nowrap" }}>
                                  <i className="bi bi-telephone-fill me-1"></i> {addr.phone}
                                  {addr.email && (
                                    <>
                                      {" • "}
                                      <i className="bi bi-envelope-fill me-1"></i> {addr.email}
                                    </>
                                  )}
                                </p>

                                {addr.is_default === 1 && (
                                  <span
                                    className="badge"
                                    style={{ backgroundColor: "#1C3F1D" }}
                                  >
                                    Default
                                  </span>
                                )}
                              </div>


                            )}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-5">
                        <i className="bi bi-geo-alt fs-1 text-muted opacity-50"></i>
                        <h6 className="text-muted mt-3">No addresses saved</h6>
                        <p className="text-muted">Your delivery addresses will appear here.</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <AddressModal
                show={modalOpen}
                onClose={closeModal}
                address={editingAddress}
                customerId={customerId}
                onAddressSaved={handleAddressSaved}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyAccount;
